import { render, staticRenderFns } from "./Adresa.vue?vue&type=template&id=31d71bb2&scoped=true&"
import script from "./Adresa.vue?vue&type=script&lang=js&"
export * from "./Adresa.vue?vue&type=script&lang=js&"
import style0 from "./Adresa.vue?vue&type=style&index=0&id=31d71bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d71bb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/atlassian/pipelines/agent/build/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect})
